// extracted by mini-css-extract-plugin
module.exports = {"page-wrapper":"PageWrapper_page-wrapper__ggfPe","page-wrapper--header-skeleton":"PageWrapper_page-wrapper--header-skeleton__9Qu8V","shimmer":"PageWrapper_shimmer__G7PLe"};